import { HTMLAttributes } from 'react';
import styled from 'styled-components';
import Paragraph from '../ui/typography/Paragraph';
import colors from '/css/colors';

export enum Brand {
    ELIMP = 'elimp',
}

const branding: Record<
    Brand,
    {
        logo: JSX.Element;
        backgroundColor: string;
        content: JSX.Element;
    }
> = {
    [Brand.ELIMP]: {
        logo: (
            <img
                src="/images/elimp-logo.svg"
                alt="Elektroimportøren logo"
                style={{ height: '26px' }}
            />
        ),
        backgroundColor: colors.orangeM4,
        content: (
            <Paragraph size="smaller">
                Få produktet du har kjøpt hos Elektroimportøren montert av
                SpotOn. Svar på noen enkle spørsmål og få fastpris på montering,
                du velger selv når du ønsker å få jobben utført i vår digitale
                kalender.
            </Paragraph>
        ),
    },
};

interface Props extends HTMLAttributes<HTMLDivElement> {
    brand: Brand;
}

export default function ProductFromExternalProviderInfo(props: Props) {
    return (
        <Card {...props}>
            <Logos className="mb-24">
                <img src="/images/logo.svg" alt="Spoton logo" />
                <LogoSeparator />
                {branding[props.brand].logo}
            </Logos>
            {branding[props.brand].content}
        </Card>
    );
}

const Logos = styled.div`
    img {
        height: 24px;
        width: auto;
        vertical-align: middle;
    }
`;

const LogoSeparator = styled.div`
    display: inline-block;
    width: 1px;
    height: 28px;
    background-color: #3e3e3e;
    margin: 0 24px;
    vertical-align: middle;
`;

const Card = styled.div<Props>`
    width: 100%;
    padding: 24px;
    border-radius: 12px;
    background: ${(props) => branding[props.brand].backgroundColor};
`;
